var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23111_37367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.896875 0.896875 0 2 0H14C15.1031 0 16 0.896875 16 2V11C16 12.1031 15.1031 13 14 13H9.66562L5.8 15.9C5.65 16.0125 5.44688 16.0312 5.275 15.9469C5.10313 15.8625 5 15.6906 5 15.5V13H2C0.896875 13 0 12.1031 0 11V2ZM5.5 4C5.5 3.44688 5.05312 3 4.5 3C3.94688 3 3.5 3.44688 3.5 4C3.5 4.55312 3.94688 5 4.5 5C5.05312 5 5.5 4.55312 5.5 4ZM9.25 4C9 4 8.76562 4.125 8.625 4.33437L6.875 6.95937L6.33437 6.28125C6.19062 6.10313 5.975 6 5.75 6C5.525 6 5.30625 6.10313 5.16563 6.28125L3.16563 8.78125C2.98438 9.00625 2.95 9.31563 3.075 9.575C3.2 9.83437 3.4625 10 3.75 10H6.25H7.75H12.25C12.5281 10 12.7812 9.84687 12.9125 9.60312C13.0438 9.35938 13.0281 9.0625 12.875 8.83438L9.875 4.33437C9.73438 4.125 9.5 4 9.25 4Z",
    fill: "#707A83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23111_37367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageImage);
export default __webpack_public_path__ + "static/media/message-image.ca4b8739502a3006bdf9b5b9131f42e4.svg";
export { ForwardRef as ReactComponent };